module.exports = __webpack_public_path__ + "static/media/deepakjain.c6f317f7.jpg";